import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import CoreValues from '@/components/CoreValues';
import Services from '@/components/Services';
import BookingForm from '@/components/BookingForm';
import Testimonials from '@/components/Testimonials';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';

const Home = () => {
  const [showBooking, setShowBooking] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const location = useLocation();

  useEffect(() => {
    // Handle scrolling to section when navigating from other pages
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  const handleBookNow = (serviceName = '') => {
    setSelectedService(serviceName);
    setShowBooking(true);
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar onBookNow={handleBookNow} />
      <Hero onBookNow={handleBookNow} />
      <CoreValues />
      <Services onBookNow={handleBookNow} />
      <Testimonials />
      <ContactForm />
      <Footer />
      
      {showBooking && (
        <BookingForm 
          isOpen={showBooking} 
          onClose={() => setShowBooking(false)}
          selectedService={selectedService}
        />
      )}
    </div>
  );
};

export default Home;